export default __webpack_public_path__ + "static/botella_4-33b11a538345f3fcf11365ad3e4f9eac.jpg";